import { initialSelectStatus } from '../select';

import { initialSubmittedDetails, getDetails } from './submittedDetails';
import { getRefId, getRefStats, initRefStats } from './refId';
import { checkKYCStatus } from './kycStatus';
import { hasBankAccount } from './bankAccount';
import { initialUserName, fetchUserName } from './username';

export { initRefStats } from './refId';
export { initialSubmittedDetails } from './submittedDetails';
export { initialUserName } from './username';

// ------------------------------------------------------------

export const profileActions = {
	/**
	 * Profile n Stuffs:
	 */
	__getSubmittedDetails: getDetails,
	__getReferralId: getRefId,
	__getRefStats: getRefStats,
	__checkKYCStatus: checkKYCStatus,
	__hasBankAccount: hasBankAccount,
	__resetProfile: () => ({
		submittedDetails: initialSubmittedDetails,
		referralID: null,
		refLink: '...',
		isVerified: 2,
		isBankAvailable: 0,
		...initialSelectStatus,
		...initialUserName,
		refStats: initRefStats,
	}),
	/**
	 * USDT Profile
	 */

	__getUserName: fetchUserName,
};
